// Angular
import { Component, inject, OnInit, signal, viewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

// Angular Material
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

// Components
import { CustomerFormComponent } from '../customer-form/customer-form.component';
import { CustomerIdpFormComponent } from '../customer-idp-form/customer-idp-form.component';

// ENUMs & Defs
import { Action } from '@constants/enum';

// Pipes
import { NgClass, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-customer-tabs',
  imports: [
    MatTabsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSidenavModule,
    MatInputModule,
    MatButtonModule,
    CustomerFormComponent,
    CustomerIdpFormComponent,
    TitleCasePipe,
    NgClass,
    RouterLink,
  ],
  templateUrl: './customer-tabs.component.html',
  styleUrl: './customer-tabs.component.scss',
})
export class CustomerTabsComponent implements OnInit {
  private route = inject(ActivatedRoute);

  readonly action = Action;

  readonly selectedTabIndex = signal<number>(0);
  readonly isFormValid = signal<boolean>(false);
  readonly isCreateForm = signal<boolean>(false);
  readonly customerKey = signal<string>(null);
  readonly pageType = signal<string>(null);

  readonly customerForm = viewChild(CustomerFormComponent);
  readonly idpForm = viewChild(CustomerIdpFormComponent);

  ngOnInit() {
    this.pageType.set(
      this.route.snapshot.params['type'] === this.action.edit ? Action.edit : Action.create,
    );
  }

  onSubmit() {
    if (this.selectedTabIndex() === 0) {
      this.customerForm()?.onSubmit();
    } else {
      this.idpForm()?.onSubmit();
    }
  }
}
